export default __webpack_public_path__ + "static/media/gmail.580a851b.svg";